import React from "react";
import { Link, useLocation } from "react-router-dom";

const Sidebar = ({ isOpen, toggleSidebar }) => {
  const location = useLocation();

  return (
    <div
      className={`fixed top-0 left-0 h-full bg-gray-800 text-white w-64 z-50 transition-transform duration-300 ${
        isOpen ? "translate-x-0" : "-translate-x-full"
      } md:translate-x-0`}
    >
      <div className="p-4 flex items-center">
        <img
          style={{ height: "11vh", width: "11vh" }}
          src="/images/logo.png"
          alt="Vamagems"
          title="Vamagems"
        />
        <h1 className="text-xl font-bold">Vamagems</h1>
        <button
          onClick={toggleSidebar}
          className="md:hidden text-white focus:outline-none"
        >
          ✖
        </button>
      </div>
      <ul className="space-y-2 p-4">
        {[
          { name: "Dashboard", path: "/" },
          { name: "Products", path: "/products" },
          { name: "Customers", path: "/contactUs" },
          { name: "Users", path: "/user" },
          { name: "Highlights Product", path: "/mostProduct" },
          { name: "Slider Image", path: "/sliderImage" },
        ].map((item) => (
          <li key={item.path}>
            <Link
              to={item.path}
              className={`block p-2 rounded ${
                location.pathname === item.path
                  ? "bg-gray-200 text-black"
                  : "hover:bg-gray-700"
              }`}
            >
              {item.name}
            </Link>
          </li>
        ))}
      </ul>

      <div className="mt-40 text-center text-sm">
        <p>
          Developed & Designed By{" "}
          <a href="mailto:techsolution.check@outlook.in" className="text-white">
            techsolution.check@outlook.in
          </a>
        </p>
      </div>
    </div>
  );
};

export default Sidebar;